import React from 'react'
import { ICalculatorCounter } from '../../../types'

const CalculatorCounter: React.FC<ICalculatorCounter> = ({step, slideStep}) => {

  const activeClass = "calculator__steps__step__active";
  const doneClass = "calculator__steps__step__center--done";

  return (
    <div className='calculator__steps'>
        <div className='calculator__steps__container'>
          <div className={`calculator__steps__step ${1 == step ? activeClass : ''}`}>
            <div className='calculator__steps__step__inner calculator__steps__step__inner--first'>
              <div className={`calculator__steps__step__center ${1 < step ? doneClass : ''}`}></div>
              <div className='calculator__steps__step__text calculator__steps__step__text--first'>
                01
              </div>
            </div>
          </div>
          <div className={`calculator__steps__step ${2 == step ? activeClass : ''}`}>
            <div className='calculator__steps__step__inner calculator__steps__step__inner--last'>
              <div className={`calculator__steps__step__center calculator__steps__step__center--last`}></div>
              <div className='calculator__steps__step__text calculator__steps__step__text--last'>
                SUM
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default CalculatorCounter
